module.exports = __webpack_public_path__ + "static/media/mp.7e3550d7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mp.svg
// module id = 981
// module chunks = 0